/* eslint-disable */
import _ from 'lodash'
export default {
  computed: {
    urlParams() {
      const queryString = location.search.slice(1)
      const queryStrings = queryString.split('&')
      const keyValueList = queryStrings.map(p => p.split('='))
      const decodedKeyValueList = keyValueList.map(p => [
        p[0],
        decodeURIComponent(p[1])
      ])
      return _.fromPairs(decodedKeyValueList)
    }
  }
}
